import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { FlexColumn, FlexRow } from "@similarweb/ui-components";

export const Used = styled(FlexRow)`
    ${setFontVariant("subtitle1", colorsPalettes.carbon[400])};
    font-weight: 400;
`;

export const ItemContainer = styled(FlexColumn)`
    gap: 16px;
    padding-bottom: 24px;
`;

export const TopicName = styled.div`
    font-weight: 500;
    margin-right: 5px;
`;

export const InputWrapper = styled.div`
    width: 340px;
`;
